export const GoldenRatio = ({ height, B_Height = 0, A_Height = 0 }) => {
  const Heigths = {
    A: 0,
    B: 0,
  };
  if (height) {
    Heigths.A = height / 1.618;
    Heigths.B = height - Heigths.A;
    // const A = height / 1.618;
    // const B = height - A;
  } else if (A_Height) {
    Heigths.A = A_Height;
    Heigths.B = A_Height * 1.618 - A_Height;
    // (Heigths.A = height / 1.618), (Heigths.B = height - Heigths.A);
  }
  return { A: Math.round(Heigths.A), B: Math.round(Heigths.B) };
};
